import { ModuleKind } from 'app/library/module/enums/module-kind.enum';
import { ModuleType } from 'app/library/module/enums/moduleType.enum';
import { IModuleDuration } from 'app/library/module/interfaces/module-duration.interface';
import { ModuleImage } from 'app/library/module/models/module-image.model';
import { ScheduledJob } from 'app/library/scheduler/models/scheduled-job.model';
import { MaxBrainTag } from 'app/library/tag/models/tag.model';
import { UpdatedBy } from 'app/projects/user/src/lib/models/updated-by.model';
import { User } from 'app/projects/user/src/lib/models/user';
import { UserExtendedAttributeWithValue } from 'app/projects/user/src/lib/models/user-attribute-with-value';
import { ICourseTemplate } from '../interfaces/course-template.query.interface';

// @dynamic
export class CourseTemplate {
    id: string;
    name: string;
    description: string;
    duration: string;
    durationTime: string;
    rawDuration: number;
    startDate: Date;
    endDate: Date;
    status: string;
    defaultPinned: boolean;
    private: boolean;
    section: boolean;
    rule: string;
    sectionRule: string;
    selfPaced: boolean;
    kind: ModuleKind;
    image: ModuleImage;
    tags: MaxBrainTag[];
    responsibleManagers: User[];
    participantCount: number;
    participantCompletedCount: number;
    participantFailedCount: number;
    participantPassedCount: number;
    isExecutionGraded: boolean;
    sectionCount: number;
    type: ModuleType;
    updatedBy: UpdatedBy;
    updatedAt: Date;
    attributes: UserExtendedAttributeWithValue[];
    digicompDuration: IModuleDuration;

    schedules: ScheduledJob[];

    constructor(courseTemplateQuery: ICourseTemplate) {
        if (courseTemplateQuery) {
            this.id = courseTemplateQuery.id.toString();
            this.name = courseTemplateQuery.name;
            this.description = courseTemplateQuery.description;
            this.duration = this.hhmm(courseTemplateQuery?.expected_duration);
            this.durationTime = this.hhmm(courseTemplateQuery?.expected_duration, true);
            this.rawDuration = courseTemplateQuery?.expected_duration;
            this.startDate = courseTemplateQuery.start_date;
            this.endDate = courseTemplateQuery.end_date;
            this.private = courseTemplateQuery.private;
            this.section = courseTemplateQuery.section;
            this.rule = courseTemplateQuery.rule;
            this.sectionRule = courseTemplateQuery.section_rule;
            this.selfPaced = courseTemplateQuery.self_paced;
            this.kind = courseTemplateQuery.kind;
            this.image = courseTemplateQuery.image ? new ModuleImage(courseTemplateQuery.image) : null;
            this.tags = courseTemplateQuery.tags?.length ? courseTemplateQuery.tags.map((tag) => new MaxBrainTag(tag)) : [];
            this.responsibleManagers = courseTemplateQuery.responsible_managers.length ? courseTemplateQuery.responsible_managers.map((manager) => new User(manager)) : null;
            this.participantCount = courseTemplateQuery.participant_count;
            this.participantCompletedCount = courseTemplateQuery.participant_completed_count;
            this.participantPassedCount = courseTemplateQuery.participant_passed_count;
            this.participantFailedCount = courseTemplateQuery.participant_failed_count;
            this.isExecutionGraded = courseTemplateQuery.is_execution_graded;
            this.sectionCount = courseTemplateQuery.section_count;
            this.type = courseTemplateQuery.type;
            this.updatedBy = courseTemplateQuery.updated_by ? new UpdatedBy(courseTemplateQuery.updated_by) : null;
            this.updatedAt = courseTemplateQuery.updated_at ? courseTemplateQuery.updated_at : null;
            if (courseTemplateQuery.schedules?.length) {
                this.schedules = courseTemplateQuery.schedules.map((schedule) => new ScheduledJob(schedule));
            }

            for (const property in courseTemplateQuery?.duration) {
                if (courseTemplateQuery?.duration[property]) {
                    this.digicompDuration = courseTemplateQuery?.duration;
                }
            }

            this.attributes = courseTemplateQuery.attributes ? courseTemplateQuery.attributes.map((query) => new UserExtendedAttributeWithValue(query.attribute, query.value)) : [];
        } else {
            this.id = null;
            this.name = null;
            this.description = null;
            this.duration = null;
            this.durationTime = null;
            this.rawDuration = null;
            this.startDate = null;
            this.endDate = null;
            this.status = null;
            this.defaultPinned = null;
            this.private = null;
            this.section = null;
            this.rule = null;
            this.sectionRule = null;
            this.selfPaced = null;
            this.kind = null;
            this.image = null;
            this.tags = null;
            this.responsibleManagers = null;
            this.participantCount = null;
            this.participantCompletedCount = null;
            this.participantFailedCount = null;
            this.participantPassedCount = null;
            this.isExecutionGraded = null;
            this.sectionCount = null;
            this.type = null;
            this.updatedBy = null;
            this.updatedAt = null;
            this.attributes = null;
            this.digicompDuration = null;
            this.schedules = null;
        }
    }

    hhmm(secs: number, returnOnlyTime = false): string {
        let minutes = Math.floor(secs / 60);
        const hours = Math.floor(minutes / 60);
        minutes = minutes % 60;
        return returnOnlyTime ? `${hours < 10 ? '0' + hours : hours}:${minutes < 10 ? '0' + minutes : minutes}` : `${hours}h ${minutes}min`;
    }
}
